import { Button, Col, Dropdown, Empty, Form, Input, List, Popover, Radio, Row, Space, message } from 'antd';
import CustomDrawer from "components/shared-components/CustomDrawer";
import React, { useState, useEffect } from 'react'
import AttachmentMenu from '../AttachmentMenu';
import { FileTextOutlined, SendOutlined, SmileOutlined, ThunderboltOutlined, MoreOutlined } from '@ant-design/icons';
import Picker from 'emoji-picker-react';
import { useMyContext } from 'Context/MyContextProvider';
import { useTemplates, useChatMode } from 'hooks/api';
import useEmojiInput from 'hooks/useEmojiInput';
import { HandleDynamicValues, HandleTemplateChange } from '../../CustomUtils.js/TemplateUtils';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import SendTemplatePreview from './SendTemplatePreview';
import NewMobilePreview from '../../Campaign/newMobilePreview';
import apiClient from 'services/apiClient';
import SelectedMediaStrip from './SelectedMediaStrip';
import ReplyComposerBar from './ReplyComposerBar';

const TemplateModal = ({ visible, onClose, onSelect, number, lastReportID }) => {
    const { buttonStyle, apiKey, isMobile } = useMyContext();
    const { templates, refetch: refetchTemplates } = useTemplates();
    const { data: chatMode } = useChatMode(number);
    const [selectedCategory, setSelectedCategory] = useState('utility');
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredTemplates, setFilteredTemplates] = useState([]);
    const [template, setTemplate] = useState(null);
    // make state for required states
    const [templateName, setTemplateName] = useState(null);
    const [templatePreview, setTemplatePreview] = useState(null);
    const [mediaLink, setMediaLink] = useState(null);
    const [templateInputs, setTemplateInputs] = useState(null);
    const [templateUrlInputs, setTemplateUrlInputs] = useState(null);
    const [dynamicValues, setDynamicValues] = useState([]);
    const [dynamicUrlButton, setDynamicUrlButton] = useState([]);
    const [mediaType] = useState('Media')
    const [mediaName, setMediaName] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openMediaModel, setOpenMediaModel] = useState(false);
    const [showTemFields, setShowTemFields] = useState(false);
    const [mobileViewTab, setMobileViewTab] = useState('fields');
    const [newMesaage, setNewMessage] = useState('');
    const [location, setLocation] = useState({
        latitude: '',
        longitude: '',
        name: '',
        address: ''
    });
    const showMediaModel = async () => {
        setOpenMediaModel(true);
    };
    // Update filtered templates when templates, search term or category changes
    useEffect(() => {
        if (!templates) return;

        if (templates.length > 0) {
            const nonCarouselTemplates = templates.filter(template =>
                !template.components?.some(comp => comp.type === 'CAROUSEL')
            );
            let filtered = [...nonCarouselTemplates];
            // Filter by search term
            if (searchTerm) {
                filtered = filtered.filter(template =>
                    template.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    template.content?.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }

            // Filter by category
            if (selectedCategory !== 'all') {
                filtered = filtered.filter(template =>
                    template.category?.toLowerCase() === selectedCategory.toLowerCase()
                );
            }
            setFilteredTemplates(filtered);
        } else {
            setFilteredTemplates([]);
        }
    }, [templates, searchTerm, selectedCategory]);

    const HandleTemplate = (value) => {
        setShowTemFields(true)
        setMediaLink(null)
        setDynamicUrlButton([])
        setDynamicValues([])
        setTemplateInputs([])
        setTemplateUrlInputs([])
        HandleTemplateChange(value, setMediaLink, setTemplateName, null, templates, null, null,
            setTemplatePreview, setTemplate, setTemplateInputs, setTemplateUrlInputs, setDynamicValues, setDynamicUrlButton, dynamicValues)
    }
    const handleCancelMediaModel = () => {
        setOpenMediaModel(false);
    };
    const HandleUploadImage = async (path, name, id) => {
        if (path) {
            setMediaLink(path)
            setMediaName(name)
            setOpenMediaModel(false)
        }
    };
    useEffect(() => {
        HandleDynamicValues(templatePreview, dynamicValues, setNewMessage)
    }, [templatePreview, dynamicValues])


    const HandleSubmit = async () => {
        if (template?.header?.format === 'LOCATION') {
            if (!location.latitude || !location.longitude) {
                message.error('Please enter both latitude and longitude for the location template.');
                return;
            }
        }

        try {
            setLoading(true);

            // Format dynamic values and button values
            const formattedDynamicValues = dynamicValues.join(',');
            const formattedButtonValues = dynamicUrlButton.join(',');

            const requestData = {
                apikey: apiKey, // Using the apiKey from context
                to: number, // Phone number passed as prop
                type: "T",
                tname: templateName,
                media_url: mediaLink || "",
                values: formattedDynamicValues,
                button_value: formattedButtonValues,
                report_id: lastReportID,
                // International chat: send the number as-is (no country-code prefixing)
                ...(chatMode?.is_international ? { int: true } : {}),
                ...(template?.header?.format === 'LOCATION' ? {
                    location: location,
                    latitude: location.latitude,
                    longitude: location.longitude,
                    loc_name: location.name,
                    loc_address: location.address
                } : {})
            };

            const response = await apiClient.post('https://sndwb.smsforyou.biz/api/send-messages', requestData);

            if (response.status === 200) {
                resetFields();
            } else {
                console.error('Error sending template:', response.data);
            }
        } catch (error) {
            console.error('Error in API request:', error.response?.data || error.message);
        } finally {
            setLoading(false);
        }
    };
    const resetFields = () => {
        setFilteredTemplates([]);
        setSearchTerm('');
        setDynamicValues([]);
        setDynamicUrlButton([]);
        setTemplateInputs([]);
        setMediaLink("");
        setTemplateName(null);
        setTemplatePreview(null);
        setTemplate(null);
        setShowTemFields(false);
        setMediaName(null);
        setNewMessage('')
        setLocation({
            latitude: '',
            longitude: '',
            name: '',
            address: ''
        });
        refetchTemplates()
        onClose();
    }

    const hasDynamicFields = (template?.header && template?.header?.format !== 'TEXT') ||
        (templateInputs && templateInputs.length > 0) ||
        (templateUrlInputs && templateUrlInputs.length > 0);

    return (
        <>
            <CustomDrawer
                title={showTemFields && templateName ? `Template: ${templateName}` : "Templates"}
                open={visible}
                onClose={resetFields}
                destroyOnClose
                width={"80vw"}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            type="primary"
                            onClick={HandleSubmit}
                            disabled={!showTemFields}
                            loading={loading}
                        >
                            Send Template
                        </Button>
                    </div>
                }
            >
                <Row gutter={[ROW_GUTTER, ROW_GUTTER]}>
                    {(!isMobile || !showTemFields) && (
                        <Col xs={24} sm={24} md={8}>
                            <div className="p-3">
                                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                    <div>
                                        <Radio.Group value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)}
                                            style={{ width: '100%' }} buttonStyle="solid">
                                            <Radio.Button value="utility" >Utility</Radio.Button>
                                            <Radio.Button value="marketing" >Marketing</Radio.Button>
                                        </Radio.Group>
                                    </div>
                                    <Input
                                        placeholder="Search templates..."
                                        onChange={e => setSearchTerm(e.target.value)}
                                        allowClear
                                    />
                                </Space>
                                <List
                                    itemLayout="horizontal"
                                    dataSource={filteredTemplates}
                                    style={{ marginTop: '16px', maxHeight: '60vh', overflowY: 'auto' }}
                                    locale={{ emptyText: 'No templates found for the selected category' }}
                                    renderItem={template => (
                                        <List.Item
                                            actions={[
                                                <Button
                                                    type="primary"
                                                    size="small"
                                                    icon={<SendOutlined />}
                                                    onClick={() => HandleTemplate(template?.name)}
                                                />
                                            ]}
                                        >
                                            <List.Item.Meta
                                                title={
                                                    <div>
                                                        {template.name || 'Unnamed Template'}
                                                    </div>
                                                }
                                            />
                                        </List.Item>
                                    )}
                                />
                            </div>
                        </Col>
                    )}
                    {!showTemFields && !isMobile &&
                        <Col xs={24} sm={24} md={16} className='d-flex justify-content-center align-items-center'>
                            <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={
                                    <span>
                                        Select a template to preview
                                    </span>
                                }
                            />
                        </Col>
                    }
                    {isMobile && showTemFields && (
                        <Col span={24}>
                            <div className="d-flex" style={{ gap: '10px' }}>
                                <Button
                                    type="dashed"
                                    style={{ flex: 1 }}
                                    onClick={() => {
                                        setShowTemFields(false);
                                        setMobileViewTab('fields');
                                    }}
                                >
                                    &larr; Back to Templates
                                </Button>
                                {hasDynamicFields && (
                                    <Radio.Group
                                        value={mobileViewTab}
                                        onChange={e => setMobileViewTab(e.target.value)}
                                        buttonStyle="solid"
                                        style={{ flex: 1, display: 'flex' }}
                                    >
                                        <Radio.Button value="fields" style={{ flex: 1, textAlign: 'center' }}>Fields</Radio.Button>
                                        <Radio.Button value="preview" style={{ flex: 1, textAlign: 'center' }}>Preview</Radio.Button>
                                    </Radio.Group>
                                )}
                            </div>
                        </Col>
                    )}
                    <Col xs={24} sm={24} md={8} style={{ display: isMobile && (!hasDynamicFields || mobileViewTab === 'preview') ? 'none' : 'block' }}>
                        {showTemFields && (
                            <>
                                {!isMobile && <h5 className='text-center'>Selected : {templateName}</h5>}
                                <SendTemplatePreview
                                    template={template}
                                    templateCategory={selectedCategory}
                                    mediaType={mediaType}
                                    showMediaModel={showMediaModel}
                                    mediaLink={mediaLink}
                                    buttonStyle={buttonStyle}
                                    mediaName={mediaName}
                                    setMediaLink={setMediaLink}
                                    templateInputs={templateInputs}
                                    templateUrlInputs={templateUrlInputs}
                                    loading={loading}
                                    openMediaModel={openMediaModel}
                                    handleCancelMediaModel={handleCancelMediaModel}
                                    HandleUploadImage={HandleUploadImage}
                                    location={location}
                                    setLocation={setLocation}
                                />
                            </>
                        )}
                    </Col>
                    <Col xs={24} sm={24} md={8} style={{ display: isMobile && hasDynamicFields && mobileViewTab === 'fields' ? 'none' : 'block' }}>
                        {showTemFields && (
                            <div>
                                <NewMobilePreview
                                    requestType={'template'}
                                    template={template}
                                    mediaLink={mediaLink}
                                    newMesaage={newMesaage}
                                />
                            </div>
                        )}
                    </Col>
                </Row>
            </CustomDrawer>
        </>
    )
}
const ChatContentFooter = (props) => {

    const {
        onSend,
        disable,
        form,
        setDisable,
        addSelectedMedia,
        beginDeviceMediaUploads,
        completeDeviceMediaUpload,
        failDeviceMediaUpload,
        removeSelectedMedia,
        selectedMedia = [],
        handleValuesChange,
        isOldChat,
        number,
        menuState,
        lastReportID,
        onSendLocation,
        contactName,
        replyingTo,
        onCancelReply,
        parentNumber = '',
    } = props
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const { inputRef, saveCursorPosition, insertAtCursor, focusInput } = useEmojiInput();
    const { isMobile } = useMyContext();

    useEffect(() => {
        if (!replyingTo || isOldChat) {
            return undefined;
        }

        const delay = isMobile ? 100 : 0;
        const timer = setTimeout(() => focusInput(), delay);
        return () => clearTimeout(timer);
    }, [replyingTo, isOldChat, focusInput, isMobile]);

    useEffect(() => {
        // Reset form input when menuState changes
        form.resetFields(['newMsg']);
        setShowEmojiPicker(false);
        setMobileMenuOpen(false);
    }, [menuState, form]);

    const GetMedia = (id, name, link) => {
        addSelectedMedia(id, name, link);
    };

    const uploadDrawerProps = {
        GetMedia,
        setDisable,
        disabled: isOldChat,
        number,
        selectedCount: selectedMedia.length,
        maxSelection: 10,
        selectedMediaIds: selectedMedia
            .filter((item) => item.id)
            .map((item) => item.id),
        beginDeviceMediaUploads,
        completeDeviceMediaUpload,
        failDeviceMediaUpload,
        parentNumber,
    };
    const onEmojiClick = (emojiObject) => {
        const emoji = emojiObject.emoji;
        const currentText = form.getFieldValue('newMsg') || '';
        insertAtCursor(
            emoji,
            currentText,
            (newText) => {
                form.setFieldsValue({ newMsg: newText });
                setDisable(false);
            }
        );
        // Keep picker open after selection
        setShowEmojiPicker(true);
    };
    const quickMessages = [
        { key: '1', label: 'Hello, how can I help you?' },
        { key: '2', label: 'Thank you for contacting us.' },
        { key: '3', label: 'We will get back to you shortly.' }
    ];

    const handleQuickMessageSelect = ({ key }) => {
        const selectedQuickMessage = quickMessages.find(message => message.key === key);
        form.setFieldsValue({ newMsg: selectedQuickMessage.label });
        // Enable the send button when a quick message is selected
        setDisable(false);
    };

    const quickMessageMenuProps = {
        items: quickMessages.map(message => ({
            key: message.key,
            label: message.label,
        })),
        onClick: handleQuickMessageSelect,
    };
    const handleTemplateSelect = (template) => {
        form.setFieldsValue({ newMsg: template.content });
        setShowTemplateModal(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!disable && !isOldChat) {
                form.submit();
            }
        }
    };

    return (
        <div className="chat-content-footer">
            <TemplateModal
                visible={showTemplateModal}
                onClose={() => setShowTemplateModal(false)}
                onSelect={handleTemplateSelect}
                lastReportID={lastReportID}
                number={number}
            />

            <Form form={form} name="msgInput" onValuesChange={handleValuesChange} onFinish={onSend}>
                <ReplyComposerBar
                    replyTo={replyingTo}
                    contactName={contactName}
                    onCancel={onCancelReply}
                />
                <SelectedMediaStrip
                    items={selectedMedia}
                    onRemove={removeSelectedMedia}
                    renderAddButton={() => (
                        <AttachmentMenu
                            {...uploadDrawerProps}
                            onSendLocation={onSendLocation}
                            isMobile={isMobile}
                            variant="add"
                        />
                    )}
                />
                {/* WhatsApp-style single-row footer */}
                <div className="wa-footer-row">

                    {/* ── Left icons ── */}
                    <div className="wa-footer-left">
                        {isMobile ? (
                            <Popover
                                content={
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '8px' }}>
                                        {/* Upload / Attachment */}
                                        <AttachmentMenu
                                            {...uploadDrawerProps}
                                            onSendLocation={onSendLocation}
                                            isMobile={isMobile}
                                            showLabel={true}
                                            onMenuSelect={() => setMobileMenuOpen(false)}
                                        />

                                        {/* Quick messages */}
                                        <Dropdown
                                            menu={{
                                                ...quickMessageMenuProps,
                                                onClick: (e) => {
                                                    handleQuickMessageSelect(e);
                                                    setMobileMenuOpen(false);
                                                }
                                            }}
                                            trigger={['click']}
                                            disabled={isOldChat}
                                        >
                                            <div className="cursor-pointer" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#52c41a' }}>
                                                <ThunderboltOutlined style={{ fontSize: '18px' }} />
                                                <span style={{ color: '#000' }}>Quick Message</span>
                                            </div>
                                        </Dropdown>

                                        {/* Template */}
                                        <div
                                            className="cursor-pointer"
                                            style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#722ed1' }}
                                            onClick={() => {
                                                setShowTemplateModal(true);
                                                setMobileMenuOpen(false);
                                            }}
                                        >
                                            <FileTextOutlined style={{ fontSize: '18px' }} />
                                            <span style={{ color: '#000' }}>Template</span>
                                        </div>
                                    </div>
                                }
                                trigger="click"
                                open={mobileMenuOpen}
                                onOpenChange={setMobileMenuOpen}
                                placement="topLeft"
                            >
                                <Button
                                    type="text"
                                    icon={<MoreOutlined style={{ fontSize: '20px' }} />}
                                    className="wa-icon-btn"
                                />
                            </Popover>
                        ) : (
                            <>
                                {/* Upload / Attachment */}
                                <span className="wa-icon-btn wa-btn-attachment">
                                    <AttachmentMenu
                                        {...uploadDrawerProps}
                                        onSendLocation={onSendLocation}
                                        isMobile={isMobile}
                                    />
                                </span>

                                {/* Emoji */}
                                <Popover
                                    content={<Picker onEmojiClick={onEmojiClick} />}
                                    trigger="click"
                                    open={showEmojiPicker}
                                    onOpenChange={(visible) => {
                                        if (!isOldChat) setShowEmojiPicker(visible);
                                    }}
                                    disabled={isOldChat}
                                >
                                    <Button type="text" icon={<SmileOutlined style={{ color: '#faad14', fontSize: '20px' }} />} className="wa-icon-btn wa-btn-emoji" disabled={isOldChat} />
                                </Popover>

                                {/* Quick messages */}
                                <Dropdown menu={quickMessageMenuProps} trigger={['click']} disabled={isOldChat}>
                                    <Button type="text" icon={<ThunderboltOutlined style={{ color: '#52c41a', fontSize: '20px' }} />} className="wa-icon-btn wa-btn-quick" disabled={isOldChat} />
                                </Dropdown>

                                {/* Template */}
                                <Button
                                    type="text"
                                    icon={<FileTextOutlined style={{ color: '#722ed1', fontSize: '20px' }} />}
                                    className="wa-icon-btn wa-btn-template"
                                    onClick={() => setShowTemplateModal(true)}
                                />
                            </>
                        )}
                    </div>

                    {/* ── Textarea (grows between icons) ── */}
                    <div className={`wa-footer-input ${isOldChat && 'bg-gray-lighter'}`}>
                        <Form.Item name="newMsg" className={`mb-0`}>
                            <Input.TextArea
                                ref={inputRef}
                                autoComplete="off"
                                autoFocus={!isMobile}
                                placeholder={isOldChat ? 'More than 24 hours have passed…' : 'Type a message'}
                                disabled={isOldChat}
                                onBlur={saveCursorPosition}
                                onSelect={saveCursorPosition}
                                onKeyDown={handleKeyDown}
                                autoSize={{ minRows: 1, maxRows: 6 }}
                                className={`wa-textarea`}
                            />
                        </Form.Item>
                    </div>

                    {/* ── Send button ── */}
                    <div className="wa-footer-right">
                        <Button
                            shape="circle"
                            type="primary"
                            htmlType="submit"
                            disabled={disable || isOldChat}
                            className="wa-send-btn"
                            icon={<SendOutlined />}
                        />
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default ChatContentFooter
